import { useMemo } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useBookkeepingBankAccounts } from './useBookkeepingBankAccounts'

export const useDefaultBookkeepingBankAccount = () => {
  const { bookkeepingBankAccounts } = useBookkeepingBankAccounts()
  const { organization } = useUserOrganization()

  const defaultBookkeepingBankAccount = useMemo(
    () =>
      bookkeepingBankAccounts.find(
        ({ id, isBankAccount, isArchived }) =>
          id === organization?.defaultBillBankAccountId && isBankAccount && !isArchived,
      ),
    [bookkeepingBankAccounts, organization?.defaultBillBankAccountId],
  )

  return { defaultBookkeepingBankAccount }
}
